export const styles = theme => ({
  title: {
    flexGrow: 1,
    marginLeft: theme.spacing.unit * 2
  },

  userName: {
    marginRight: theme.spacing.unit * 2
  }
})



// WEBPACK FOOTER //
// ./src/components/Header/styles.js